import { CloseIcon } from '@protector/icons';
import type { RegionalOverviewError } from 'querys/regional-overview/regional-overview.query.models';
import { useTranslation } from 'react-i18next';

import { MissingConfigContainer, MissingConfigIconWrapper, MissingConfigMessage } from './field-error-detail.styles';

interface FieldErrorDetailComponentProps {
  error?: RegionalOverviewError;
}
const FieldErrorDetailComponent = ({ error }: FieldErrorDetailComponentProps) => {
  const [t] = useTranslation();

  const message = t(`pages.disease_risk.error_code.${error?.code}`, {
    defaultValue: `${t('pages.disease_risk.failure_message')}`
  });

  return (
    <MissingConfigContainer>
      <MissingConfigIconWrapper>
        <CloseIcon />
      </MissingConfigIconWrapper>
      <MissingConfigMessage>{message}</MissingConfigMessage>
    </MissingConfigContainer>
  );
};

export default FieldErrorDetailComponent;
